import React, { useState } from 'react';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowDropDown, BeenhereRounded } from '@material-ui/icons';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import CardIcon from 'components/Card/CardIcon';
import { Collapse } from '@material-ui/core';
import Card from 'components/Card/Card';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
});

function CardContainer(props) {
  const { icon, iconColor, children, onClick, permission, collapse = false } = props;
  const { title, titleClassName } = props;
  const { style, cardBodyStyle } = props;
  const classes = useStyles();
  const [collapsed, setCollapsed] = useState(false);

  function handleCollapse() {
    if (collapse === false) return;
    setCollapsed((collapsed) => !collapsed);
  }

  return (
    <Card style={style}>
      {icon !== null && (
        <CardHeader icon onClick={handleCollapse}>
          {icon !== undefined ? (
            <AllowedGuard
              permission={permission}
              component={
                <CardIcon color={'primary'}>
                  <BeenhereRounded />
                </CardIcon>
              }
            >
              <CardIcon
                color={iconColor || 'success'}
                pointer={onClick !== undefined}
                onClick={onClick}
              >
                {icon}
              </CardIcon>
            </AllowedGuard>
          ) : (
            <CardIcon color={iconColor || 'primary'}>
              <BeenhereRounded />
            </CardIcon>
          )}
          <h4 className={titleClassName || classes.cardIconTitle}>
            {title}
            {collapse && <ArrowDropDown />}
          </h4>
        </CardHeader>
      )}
      {icon === null && title !== undefined && (
        <CardHeader onClick={handleCollapse}>
          <h4 className={titleClassName || classes.cardIconTitle}>
            {title}
            {collapse && <ArrowDropDown />}
          </h4>
        </CardHeader>
      )}
      <CardBody style={cardBodyStyle}>
        {collapse ? <Collapse in={!collapsed}>{children}</Collapse> : children}
      </CardBody>
    </Card>
  );
}

export default CardContainer;
